import {Address} from '@store/common/address.model';
import {InvoiceClient, InvoiceStatus, InvoiceType} from '@store/invoices/invoices';
import {ExecutionLine} from '@store/invoices/executionLines';
import {Pagination} from '@store/common/pagination.model';
import {TableFilter, TableFilterType} from '@store/common/tableFilter.model';
import {PaymentTerm, TaxRule} from '@store/common/organisation.enums';

export interface InvoiceLine {
  name: string;
  kind?: number;
  executedAt?: Date;
  puBuy: number;
  puSell: number;
  quantity: number;
}

export interface PurchaseStatementGroupedAction {
  status?: InvoiceStatus;
}

export interface PurchaseStatementCreationDto {
  invoiceDate: Date;
  invoiceReceivedAt: Date;
  invoiceNumber: string;
  qrCodeData: string;
  designation: string;
  invoiceAmount: number;
  supplierInvoiceLines: InvoiceLine[];
  executionLineIds: number[];
}

export interface Site {
  id?: number;
  address?: Address;
  client?: string;
  phone?: string;
  site?: string;
  country?: string;
}

export interface PurchaseStatementDetails {
  id: number;
  bvrRef?: string;
  currency: string;
  date: Date;
  invoiceNumber: string;
  qrCodeData: string;
  invoiceReceivedAt: Date;
  reminderDate: Date;
  dueDate: Date;
  invoiceDate: Date;
  totalAmountNoVatInCents: number;
  totalAmountVatIncludedInCents: number;
  invoiceAmount: number;
  organisationAndUnitName: string;
  invoiceRef: string;
  clients: InvoiceClient[];
  supplierInvoiceLines: ExecutionLine[];
  accountingTransferDate?: Date;
  paymentTermsNumDays: PaymentTerm;
  type?: InvoiceType;
  invoiceOriginId?: number;
  changeRate?: number;
  totalAmountVatIncludedInCentsCHF: number;
  status: InvoiceStatus;
  comment: string;
  cancellationReason: string;
  taxRule: TaxRule;
}

export interface PurchaseStatementsFilters {
  status?: InvoiceStatus;
  search: string;
  from?: Date;
  to?: Date;
  filterAccountantTransferred: boolean;
  tableFilters: TableFilter[];
}

export namespace PurchaseStatementsFilters {
  export const initTableFilters = () => TableFilterType.initTableFilters([
    TableFilterType.CLIENT_ORGANISATION,
    TableFilterType.CLIENT_ORGANISATION_UNIT,
    TableFilterType.SUPPLIER_ORGANISATION,
    TableFilterType.SUPPLIER_ORGANISATION_UNIT,
  ]);
}

export interface PurchaseStatementsPagination extends Pagination {
  data: PurchaseStatement[];
}

export interface PurchaseStatementUI {
  id: number;
  selected: boolean;
}

export interface PurchaseStatement {
  id: number;
  createdAt: Date;
  invoiceNumber?: string;
  supplierName?: string;
  supplierUnitName?: string;
  clientCount: number;
  unitCount: number;
  clientName: string;
  unitName: string;
  dueDate: string;
  totalAmountNoVatInCents: number;
  totalAmountVatIncludedInCents: number;
  currency: string;
  status: InvoiceStatus;
  invoiceDate: Date;
  invoiceRef: string;
  accountingTransferDate?: Date;
}
